import { qiNiuUploader } from "./utilities/initUpload.js";
import hotkeys from 'hotkeys-js';
const dynamic = require("tpl/dynamic/dynamic.html");
const imglist = require('tpl/sns/imglist.html');
const organization = require('tpl/sns/organization.html');
const interest = require('tpl/sns/interest.html');
const information = require('tpl/sns/information.html');
const $ajax = window.util.ajax;

const __data = {
    type: 0,
    // 页码
    page: 2,
    weiBoId: 0,
    PAGE_LIMIT: 20,
    // 是否有下一页
    hasNextPage: true,
    uid: $('#_env').data('uid'),
    organizationNum: 1,
    interesteNum: 1,
    isLoadMore: false,
    isScroll: false
};

const __sns = {
    init() {
        let dynList = $('._dynamicMainContent');
        let len = dynList.length;

        if ($('.sns-init').length) {
            this.initEmojiPicker();
            this.initUpload();
            this.initHotKey();
        }
        // 让页面跳到顶部
        $('html').scrollTop(0);
        __data.type = window.util.queryString().type || 0;

        __data.weiBoId = dynList.eq(len - 1).data('id');
        __data.maxWeiBoId = dynList.eq(0).data('id');
        __sns.setLoadMoreBtnStatus();
        // 滚动到底部加载更多数据

        if ($('._dynamicMainContent').length < __data.PAGE_LIMIT) {
            __data.hasNextPage = false;
        } else {
            __data.hasNextPage = true;
        }
        if ($('._mainCommunityContent').length) {
            let $mcc = $("._mainCommunityContent");
            let $fixBar = $("._fixPosSider");
            let fixBarWidth = parseInt($fixBar.css("width"));

            __data.fixBarTop = $fixBar.offset().top + 41;
            __data.headerHeight = parseInt($("._fixHeader").height());
            __data.fixBarLeftPos = $mcc.offset().left + parseInt($mcc.css("width")) - fixBarWidth;
        }

        if ($('._scrollContent').length) {
            __data.loadMoreLabel = $('._loadMoreTip');
            __data.scrollContent = $('._scrollContent');
            __data.beginLoadHeight = __data.scrollContent.offset().top + __data.scrollContent.outerHeight();
            __sns.setLoadLabelText();
        }
        __sns.getFullRightBarPos();

        $(window).on("scroll", __sns.scrollHandle);

    },
    // 滚动页面时候的操作
    scrollHandle() {
        __sns.fixPosBarHandle();
        __sns.scrollLoadData();
    },
    getFullRightBarPos() {
        let $fixBar = $("._fixPosSider");
        let fixBarTop = $fixBar.offset().top;
        let fixBarHeight = parseInt($fixBar.css("height"));
        let orgHeight = parseInt($('.sns-r-organization').height());
        let inforHeight = parseInt($('.sns-r-information').height());
        let bannerHeight = parseInt($('.sns-r-banner-tmp').height());

        __data.fixBarHeight = fixBarTop + fixBarHeight + orgHeight + inforHeight + bannerHeight;
    },
    // 固定右侧在页面同一位置
    fixPosBarHandle() {
        let $fixBar = $("._fixPosSider");
        let width = parseInt($fixBar.css("width"));
        let { scrollTop: st } = document.documentElement;

        if (st > __data.fixBarHeight - __data.headerHeight) {
            if (!__data.isScroll) {
                __data.isScroll = true;
                let currTop = __data.fixBarHeight - __data.fixBarTop - __data.headerHeight;

                $fixBar
                    .find("._hideBlockInScroll").hide()
                    .end().find("._fixPosSider").addClass("has-margin")
                    .end()
                    .animate({ top: currTop }, () => {
                        $fixBar.css({ "left": __data.fixBarLeftPos, position: "fixed", top: 50, 'z-index': 10 })
                    });
            }

        } else {
            if (st <= __data.fixBarTop + __data.fixBarHeight) {
                if (__data.isScroll) {
                    __data.isScroll = false;
                    $fixBar
                        .css("opacity",0)
                        .find("._hideBlockInScroll").show()
                        .end()
                        .css({ position: "static"})
                        .animate({opacity: 1 })
                        .find("._fixPosSider").removeClass("has-margin");
                }

            }
        }
    },
    initEmojiPicker() {
        // 初始化表情包插件
        window.emojiPicker = new EmojiPicker({
            emojiable_selector: '[data-emojiable=true]',
            assetsPath: '//static.scimall.org.cn/lib/plugin/emoji/img/',
            popupButtonClasses: 'fa fa-smile-o'
        });
        window.emojiPicker.discover();
    },
    initUpload() {
        // 初始化上传图片插件
        qiNiuUploader($("._uploadTopicImg"), {
            uploaderParmas: {
                fileNumLimit: 9
            },
            isCreateOwnImg: true,
            qNbeforeFileQueued: (_, file) => {
                if ($("._imgListBox>p").length > 8) {
                    layer.msg('最多上传9张');
                    _.cancelFile(file);
                    return false;
                }
            },
            qNuploadSuccess: (name, url) => {
                let data = {
                    name: name,
                    url: url
                };

                $('.loading').remove();
                $('._imgListBox').append(imglist(data));
            },
            qNuploadStart: () => {
                $('._imgListBox').append('<p class="loading">上传中...</p>');
            }
        });
    },
    initHotKey() {
        hotkeys('ctrl+Enter, command+return', function () {
            __sns.pushDynamics();
        });
        hotkeys.filter = function (event) {
            var tagName = (event.target || event.srcElement).tagName;

            hotkeys.setScope(/^(INPUT|TEXTAREA|SELECT)$/.test(tagName) ? 'input' : 'other');
            return true;
        };
    },
    // 加载更多的标签显示的文字
    setLoadLabelText() {
        let text = '';

        // 如果还有下一页
        if (__data.hasNextPage) {
            // 如果在加载中
            if (__data.isLoadMore) {
                text = '加载中...';
                // 如果加载完成
            } else {
                text = '加载更多';
            }
            // 没有数据
        } else {
            text = '暂无更多~';
        }
        __data.loadMoreLabel.text(text);
    },
    // 滚动加载数据
    scrollLoadData(e) {
        let { scrollTop: st, scrollHeight: sc, clientHeight: ch } = document.documentElement;

        // 如果页面高度加上滚动过去的高度大于了总的页面内容高度
        // 就判断是否加载更多
        if (__data.hasNextPage) {
            if (st + ch >= sc - 480) {
                if (!__data.isLoadMore) {
                    __data.isLoadMore = true;
                    __sns.setLoadLabelText();
                    __data.hasNextPage = false;
                    __sns.getDynamicsList();
                }
            }
        }

        __sns.fixPosBarHandle();
    },
    getDynamicsList() {
        $ajax({
            url: '/sns/getWeibolist',
            type: 'post',
            data: {
                page: __data.page,
                pageSize: __data.PAGE_LIMIT,
                type: __data.type,
                weiBoId: __data.weiBoId,
                maxWeiBoId: __data.maxWeiBoId,
                topicId: 0
            },
            callback: ({ data }) => {
                let datas = data.list;

                if (datas.length == 0) {
                    __data.hasNextPage = false;
                } else {
                    if (datas.length < __data.PAGE_LIMIT) {
                        __data.hasNextPage = false;
                    } else {
                        setTimeout(() => {
                            __data.hasNextPage = true;
                            __sns.setLoadLabelText();
                        }, 200);
                    }
                    __data.weiBoId = datas[datas.length - 1].id;
                    // 对列表的点赞转发评论加上是否上万的处理
                    let _list = data && __sns.dealNumberByTenThousand(data.list);

                    _list.map(item => {
                        item.showContent = item.content;
                        item.dealContent = __sns.dealContentText(item.content1);
                        item.ctime = window.util.getPubtime(new Date().getTime() / 1000 - item.create_time);
                        if (item.sourceWeibo.id) {
                            item.sourceWeibo.dealContent = __sns.dealContentText(item.sourceWeibo.content1);
                        }
                        return item;
                    });
                    __data.weiBoId = _list[_list.length - 1].id;
                    __data.maxWeiBoId = _list[0].id;
                    __data.page++;
                    __data.isLoadMore = false;

                    $('._userDynamicContent').append(dynamic({ list: _list, type: 1, uid: __data.uid }));
                    __sns.setLoadMoreBtnStatus();
                    __data.beginLoadHeight = __data.scrollContent.offset().top + __data.scrollContent.outerHeight();
                }

                __sns.setLoadLabelText();
            }
        });
    },
    // 处理数字的操作
    // 根据数量是否大于万来确定。如果大于万。显示多少万
    dealNumberByTenThousand(data, keys = ["comment_count", "support_count"]) {
        let keysSet = new Set(keys);

        return data.map(item => {
            for (let key in item) {
                if (keysSet.has(key)) {
                    item[key + '_deal'] = window.util.getNumberByTenThousand(item[key]);
                }
            }
            return item;
        });
    },
    // ##2#6159#天气话题## 天哪天企鹅晚饭",//##1 是@用户 ##2是话题  第二位数字是代表用户ID或者话题ID
    dealContentText(str) {
        const USER = /##1#(\d+)(#.+?#)#/g;
        const TOPIC = /##2#(\d+)(#.+?#)#/g;

        let endStr = str.replace(USER, (match, p1, p2) => {
            return '<a class="highlight" href="/user/index?uid=' + p1 + '">@' + p2 + '</a>';
        }).replace(TOPIC, (match, p1, p2) => {
            return '<a class="highlight" href="/sns/topicDetail?id=' + p1 + '">' + p2 + '</a>';
        });

        return endStr;
    },
    // 发布动态
    pushDynamics() {
        let dynamicsText = $('.emoji-wysiwyg-editor').html();
        let type = $('._typeText').attr('data-type');
        let nickName = $('#_currUserLogo').attr("alt");
        let imgDom = $("._topicImg");
        let imgs = [];
        let { pathname } = window.location;
        let sourceType = 'weibo';
        let sourceId = 0;

        imgDom.each(function () {
            imgs.push($(this).attr('src'));
        });

        if (!dynamicsText) {
            layer.msg('请先填写您的想法');
            return false;
        }
        if (pathname.indexOf('topicDetail') > -1) {
            sourceId = window.util.queryString().id;
        }
        __sns.submitDataHandle('/sns/issueWeibo', 'post', {
            issue: type,
            content: dynamicsText,
            from: 'web',
            image: JSON.stringify(imgs),
            nickName: nickName,
            sourceType: 'weibo',
            h5Desc: '',
            repostId: 0,
            sourceId: sourceId,
            iscomment: 0
        }, ({ data }) => {
            layer.msg(data.msg);
            $(".emoji-wysiwyg-editor").html('');
            $("._imgListBox").html('');
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        });
    },
    dynamicsType() {
        let $types = $(this).parents('.sns-options-type');

        $types.hasClass('optionsType') ? $types.removeClass('optionsType') : $types.addClass('optionsType');
    },
    typelist(event) {
        event.stopPropagation();
        let [txt, type] = [$(this).text(), $(this).attr('data-type')];

        $(this).addClass('types-active').siblings().removeClass('types-active');
        $('._typeText').text(txt).attr('data-type', type);
        $('.sns-options-type').addClass('optionsType');
    },
    getOrganization() {
        __data.organizationNum++;
        __sns.submitDataHandle('/sns/ajaxRecommendData?type=2&click_num=' + __data.organizationNum, 'get', '', (data) => {
            if (data.data.length < __data.PAGE_LIMIT) {
                __data.hasNextPage = false;
            } else {
                __data.hasNextPage = true;
            }

            __data.page++;
            $('._organizationBox').html(organization(data.data));
        });
    },
    getInterest() {
        __data.interesteNum++;
        __sns.submitDataHandle('/sns/ajaxRecommendData?type=1&click_num=' + __data.interesteNum, 'get', '', (data) => {
            if (data.data.length < __data.PAGE_LIMIT) {
                __data.hasNextPage = false;
            } else {
                __data.hasNextPage = true;
            }
            __data.page++;
            $('._interesteBox').html(interest(data.data));
        });
    },
    getInformation() {
        __sns.submitDataHandle('/sns/recommend', 'get', '', (data) => {
            if (data.data.length < __data.PAGE_LIMIT) {
                __data.hasNextPage = false;
            } else {
                __data.hasNextPage = true;
            }
            __data.page++;
            $('._informationBox').html(information(data));
        });
    },
    reloadDataBtn(event) {
        event.preventDefault();

        let type = $(this).data('type');

        // 1 感兴趣的人 2 更新组织  3 推荐资讯
        if (type == 1) {
            __sns.getInterest();
        }
        if (type == 2) {
            __sns.getOrganization();
        }
        if (type == 3) {
            __sns.getInformation();
        }
    },
    submitDataHandle(url, type, data, callBack) {
        $ajax({
            type: type,
            url: url,
            data: data,
            dataType: 'json',
            callback: function (json) {
                if (json.code != 0) {
                    layer.msg(json.error? json.error[0].value : json.msg);
                    return false;
                }
                callBack && callBack(json);
            }
        });
    },
    removeTopicImg() {
        $(this).parent('p').remove();
    },
    iSelectField() {
        let $ele = $(".emoji-wysiwyg-editor");

        $ele.focus();

        if (window.getSelection) {
            // IE9 and non-IE
            let sel = window.getSelection();

            if (sel.getRangeAt && sel.rangeCount) {
                let range = sel.getRangeAt(0);

                range.deleteContents();
                range.setStart($ele[0].firstChild, 1);
            }
        } else if (document.selection && document.selection.type != 'Control') {
            let ierange = document.selection.createRange(); // 获取光标位置
            let srcele = ierange.parentElement(); // 获取到当前元素
            let copy = $ele[0].createTextRange();

            copy.moveToElementText(srcele);
            copy.moveStart("character", 1); // 改变光标位置，实际上我们是在记录cursor的数量.
        }
    },
    insertTopic() {
        $(".emoji-wysiwyg-editor").html('##');
        __sns.iSelectField();
    },
    dynamicsText() {
        let length = $(".emoji-wysiwyg-editor").text().length;

        $('._textCount').text(length);
    },
    // 加关注操作
    followingHandle(e) {
        e.preventDefault();
        let $this = $(this);
        let id = $this.data("id");

        __sns.submitDataHandle('/org/ajaxAddFollow', 'post', { crowd_id: id }, (data) => {
            layer.msg("添加关注成功");
            $this.html('已关注')
                .addClass("unfollow-skin _notFollowBtn")
                .removeClass("_followBtn");
        });
    },
    // 取消关注按钮
    removeFollowingHandle(e) {
        e.preventDefault();
        let $this = $(this);
        let [id, type] = [$this.data("id"), $this.data("type")];

        __sns.submitDataHandle('/org/ajaxDelFollow', 'post', { crowd_id: id }, (data) => {
            layer.msg("取消关注成功");
            $this.html('加关注')
                .removeClass("unfollow-skin _notFollowBtn")
                .addClass("_followBtn");
        });
    },
    unFriend() {
        let $this = $(this);
        let id= $this.data("id");

        __sns.submitDataHandle('/friend/ajaxSolveFriend', 'post', { uid: id }, (data) => {
            layer.msg("解除好友成功");
            $this.html('加好友')
                .removeClass("unfollow-skin _unFriend")
                .addClass("_beFriend");
        });
    },
    // 申请加好友
    beFriend() {
        let $this = $(this);
        let id= $this.data("id");

        __sns.submitDataHandle('/friend/ajaxAddFriend', 'post', { uid: id }, (data) => {
            layer.msg("申请好友成功");
            $this.html('已申请好友')
                .removeClass("_beFriend");
        });
    },
    hideTypeBox(e) {
        let className = e.target.className;

        if (className.indexOf('_dynamicsType') > -1 || className.indexOf('_typeList') > -1) {
            return false;
        }
        $('.sns-options-type').addClass('optionsType');
    },
    // 处理动态内容文本。判断是否当前的文本的长度满足了显示
    // 查看全文按钮的条件，如果满足了。就显示查看全文按钮
    setLoadMoreBtnStatus() {
        let content = $("._msgWords");
        let maxLimitNum = 92;
        let msg = '';
        let html = '';
        let urlList = [];

        content.each((index, item) => {
            var list = $(item).find('.highlight');

            urlList = [];
            msg = $(item).text();
            html = $(item).html();
            list.each((index, item) => {
                urlList.push($(item).attr('href'));
            });
            $(item).attr("data-text", html);
            if (msg.length > maxLimitNum) {
                $(item)
                    .html(__sns.restoreHtmlStr(msg.slice(0, maxLimitNum), urlList) + "...")
                    .parent().find("._lookFullDymContent").slideDown();
            }
        });
    },
    // 恢复截取的长度的文本中的话题
    restoreHtmlStr(str, urlList = []) {
        let _str = '';
        let arr = str.split(/(#.+?#)/);
        let index = 0;
        let strArr = arr.map((item) => {
            if (item.match(/(#.+?#)/)) {
                item = `<a class="highlight" href="${urlList[index]}">${item}</a>`;
                index++;
            }
            return item;
        });

        return strArr.join('');
    },
    // 点击查看全文按钮。显示全文
    showFullContentTitle() {
        let $this = $(this);
        let msgContext = $this.parent().find("._msgWords");
        let fullMsg = msgContext.attr("data-text");
        let showHtml = msgContext;
        let currMsg = msgContext.html();

        if ($this.hasClass("_slideUp")) {
            $this.text("查看全部");
        } else {
            $this.text("收起");
        }
        msgContext.html(fullMsg).attr("data-text", currMsg);
        $this.toggleClass("_slideUp");
    },
    addShowDetail() {
        let idx = $(this).attr("data-index");
        let tip = ['点赞', '评论', '分享', '举报', '删除'];

        if (idx == '0') {
            tip[0] = $(this).hasClass('_hasThumbs') ? '取消点赞' : '点赞';
        }
        $(this).append('<span class="appendOptionsTip">' + tip[idx] + '</span>');
    },
    removeDetail() {
        $('.appendOptionsTip').remove();
    }
};

$(function () {
    __sns.init();
    $(document)
        .on("click", __sns.hideTypeBox)
        .on("click", "._insertTopic", __sns.insertTopic)
        .on("click", "._dynamicsType", __sns.dynamicsType)
        .on("click", "._typeList p", __sns.typelist)
        .on("input keyup", "._dynamicsText", __sns.dynamicsText)
        .on("click", "._reloadDataBtn", __sns.reloadDataBtn)
        .on("click", "._followBtn", __sns.followingHandle)
        .on("click", "._notFollowBtn", __sns.removeFollowingHandle)
        .on("click", "._beFriend", __sns.beFriend)
        .on("click", "._unFriend", __sns.unFriend)
        .on("click", "._pushDynamics", __sns.pushDynamics)
        .on("click", "._removeTopicImg", __sns.removeTopicImg)
        .on("mouseover", "._detailOptions", __sns.addShowDetail)
        .on("mouseout", "._detailOptions", __sns.removeDetail)
        .on("click", "._lookFullDymContent", __sns.showFullContentTitle)
    ;
});
